<template>
  <a-modal v-model="editBankModal"
           :closable="false"
           :keyboard="false"
           :maskClosable="false"
           :title="isUpdate?'更换银行信息':'请补充您的收款银行账号信息'"
           @cancel="handleCancel">
    <div class="login">
      <a-form :form="form"
              @submit="onSubmit">
        <a-form-item label="开户银行">
          <a-input size="large"
                   placeholder="请输入开户银行"
                   v-decorator="['bankName', {rules: [{ required: true, message: '请输入开户银行', whitespace: true}]}]">
            <a-icon slot="prefix"
                    type="bank" />
          </a-input>
        </a-form-item>
        <a-form-item label="银行账号">
          <a-input size="large"
                   placeholder="请输入银行账号"
                   v-decorator="['bankAccount', {rules: [{ required: true,message: '请输入银行账号', whitespace: true}]}]">
            <a-icon slot="prefix"
                    type="credit-card" />
          </a-input>
        </a-form-item>
        <a-form-item label="账户名称">
          <a-input size="large"
                   disabled
                   placeholder="账户名称"
                   v-decorator="['expertName', {rules: [{ required: true,message: '请输入账户名称', whitespace: true}]}]">
          </a-input>
        </a-form-item>
        <a-form-item>
        </a-form-item>
      </a-form>
    </div>
    <template slot="footer">
      <a-button key="back"
                @click="handleCancel">
        下次再填
      </a-button>
      <a-button :loading="submitLoading"
                key="submit"
                @click="onSubmit"
                type="primary">提交
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { EditBankAccount } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { NEXT_EDIT_BANK_MODAL } from '@/store/mutation-types'
import { EXPERT_PAYMENTMETHOD, ACTION_TYPE } from '@/epp/sysContentMange/util/sysContentMangeUtil'
import { GetContentResourceByKey } from '@/epp/sysContentMange/api/sysContentMangeApi'

export default {
  name: 'EditBankModal',
  props: {
    expertInfo: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      editBankModal: false,
      submitLoading: false,
      form: this.$form.createForm(this),
      isUpdate: true,
      expertId: ''
    }
  },
  watch: {
    expertInfo (val) {
      const showModal = this.$ls.get(NEXT_EDIT_BANK_MODAL)
      // 支付方式为银行转账的 and 本人未录入银行账号数据的
      if (!showModal && (!val.openingBank || !val.bankAccount)) {
        GetContentResourceByKey(EXPERT_PAYMENTMETHOD, ACTION_TYPE.business).then(res => {
          if ("银行转账" == res) {
            this.init(val, false)
          }
        })
      }
    }
  },
  methods: {
    init (expertInfoData, isUpdate) {
      this.editBankModal = true
      this.submitLoading = false
      this.isUpdate = isUpdate
      this.expertId = expertInfoData.id
      this.$nextTick(() => {
        this.form.setFieldsValue({
          expertName: expertInfoData.expertName
        })
      })
    },
    onSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.onHandleEditPhone(values)
      })
    },
    async onHandleEditPhone (values) {
      this.submitLoading = true
      values.id = this.expertId
      const res = await EditBankAccount(values)
      if (res.code == 200) {
        this.$message.success("提交成功")
        this.$emit('success', values.mobile)
        this.editBankModal = false
      } else {
        this.$message.error("提交失败")
      }
      this.submitLoading = false
    },
    handleCancel (e) {
      e.preventDefault()
      if (this.submitLoading) {
        this.$message.warning("正在提交中，请稍后...")
        return
      } else {
        this.editBankModal = false
      }
      this.$ls.set(NEXT_EDIT_BANK_MODAL, true)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>